// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide-enter-active[data-v-09a4f7bd],.slide-leave-active[data-v-09a4f7bd]{transition:max-height .2s ease,opacity .1s ease}.slide-enter[data-v-09a4f7bd],.slide-leave-to[data-v-09a4f7bd]{max-height:0;opacity:0;overflow:hidden}.slide-enter-to[data-v-09a4f7bd],.slide-leave[data-v-09a4f7bd]{max-height:565px;opacity:1;overflow:hidden}", ""]);
// Exports
module.exports = exports;
